import React from "react";

export const HeaderPremiumIcon = () => {
  return (
    <svg
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 1.49306C3.54167 1.49306 3.16667 1.15712 3.16667 0.746529C3.16667 0.326681 3.54167 0 4 0C4.45833 0 4.83333 0.326681 4.83333 0.746529C4.83333 1.15712 4.45833 1.49306 4 1.49306ZM0.677 1.18489C1.04167 1.18489 1.33333 1.45543 1.33333 1.78211C1.33333 2.11805 1.04167 2.37934 0.677 2.37934C0.302 2.37934 0 2.11805 0 1.78211C0 1.45543 0.302 1.18489 0.677 1.18489ZM7.34367 1.18489C7.70833 1.18489 8 1.45543 8 1.78211C8 2.11805 7.70833 2.37934 7.34367 2.37934C6.96867 2.37934 6.66667 2.11805 6.66667 1.78211C6.66667 1.45543 6.96867 1.18489 7.34367 1.18489ZM1.40633 5.30961L0.854333 2.60329C1.021 2.57523 1.17733 2.49132 1.30233 2.39785C1.646 2.67795 2.08367 2.94849 2.50033 2.94849C3.00033 2.94849 3.40667 2.2578 3.688 1.67939C3.78167 1.70746 3.89633 1.73553 4.00067 1.73553C4.105 1.73553 4.21933 1.70746 4.31333 1.67939C4.59467 2.2581 5.001 2.94849 5.501 2.94849C5.91767 2.94849 6.35533 2.67795 6.699 2.39785C6.824 2.49132 6.98033 2.57523 7.147 2.60329L6.595 5.30961H1.40733H1.40633ZM1.29167 5.54283H6.70833V6H1.29167V5.54283Z"
        fill="#C6B7FF"
      />
    </svg>
  );
};
